/* Shoppable reels: each tile plays muted while it is on screen and pauses
   when it leaves; the sound button unmutes that one tile and mutes the rest.
   Add to cart goes through the cross-sell handler already on the page. */
class AnyraReels extends HTMLElement {
  connectedCallback() {
    this.frames = Array.from(this.querySelectorAll('[data-reel]'));
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.frames.forEach(f => {
      const v = f.querySelector('video');
      if (!v) return;
      v.muted = true;
      const btn = f.querySelector('[data-reel-sound]');
      btn && btn.addEventListener('click', () => this.toggleSound(f, v));
      v.addEventListener('click', () => { v.paused ? v.play().catch(() => {}) : v.pause(); });
    });
    // Posters are set when the rail comes near the screen, so eight of them do not race the hero image on load.
    const posters = () => this.frames.forEach(f => {
      const v = f.querySelector('video[data-poster]');
      if (v && !v.poster) v.poster = v.dataset.poster;
    });
    if ('IntersectionObserver' in window) {
      const near = new IntersectionObserver(es => {
        if (es.some(e => e.isIntersecting)) { posters(); near.disconnect(); }
      }, { rootMargin: '800px 0px' });
      near.observe(this);
    } else posters();
    if (this.reduced || !('IntersectionObserver' in window)) return;
    this.io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        const v = en.target.querySelector('video');
        if (!v) return;
        if (en.isIntersecting && en.intersectionRatio >= 0.6) v.play().catch(() => {});
        else v.pause();
      });
    }, { threshold: [0, 0.6] });
    this.frames.forEach(f => this.io.observe(f));
  }
  toggleSound(frame, video) {
    const on = video.muted;
    this.frames.forEach(f => {
      const v = f.querySelector('video');
      if (!v) return;
      v.muted = true;
      f.classList.remove('is-unmuted');
      const b = f.querySelector('[data-reel-sound]'); b && b.setAttribute('aria-label', 'Turn sound on');
    });
    if (on) {
      video.muted = false;
      frame.classList.add('is-unmuted');
      const b = frame.querySelector('[data-reel-sound]'); b && b.setAttribute('aria-label', 'Turn sound off');
      video.play().catch(() => {});
    }
  }
}
if (!customElements.get('anyra-reels')) customElements.define('anyra-reels', AnyraReels);
